// extracted by mini-css-extract-plugin
export default {"errorMessage":"tM9cn3Ycx6u5SQc42eoK","inputPostLabel":"Y7eBLMWNuVEoRO6wrqE7"};